import { connect } from 'react-redux';
import UserDashBoard from './users';

export default connect(({ users, account, token, curProjectID }) => ({ users, account, token, curProjectID }))(UserDashBoard);


// WEBPACK FOOTER //
// ./src/containers/index.js